import PropTypes from "prop-types";
import React, { useMemo, useEffect } from "react";
import { Select } from "@mantine/core";
import { formatCollection } from "./formatCollection";
import { useStylesCollectionSelect } from "./mantine/stampTabContent/useStylesCollectionSelect";

const SearchableSelect = ({
  selectCollections,
  disabled,
  onSelectedOptionCollection,
  selectedOptionCollection,
}) => {
  const { classes: collectionSelectClasses } = useStylesCollectionSelect();
  const options = useMemo(() => {
    return selectCollections
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((collection) => ({
        value: collection.cid.toString(),
        label: formatCollection(collection.name, collection.cid),
      }));
  }, [selectCollections]);

  const handleChange = (value) => {
    const selected = selectCollections.find(
      (collection) => collection.cid.toString() === value,
    );
    if (selected) {
      onSelectedOptionCollection(selected);
    } else {
      onSelectedOptionCollection(null);
    }
  };
  // Reset input when disabled
  useEffect(() => {
    if (disabled) {
      onSelectedOptionCollection(null);
    }
  }, [disabled, options]);
  return (
    <Select
      className={collectionSelectClasses.collectionSelectDropdown}
      placeholder={
        disabled
          ? "No Assigned Collection"
          : "Search...           (Required Field)"
      }
      data={options}
      searchable
      nothingFoundMessage="No Collections Found, click “+” to create one"
      disabled={disabled}
      value={
        disabled ? null : selectedOptionCollection?.cid?.toString() || null
      }
      onChange={handleChange}
      required={!disabled}
    />
  );
};

SearchableSelect.propTypes = {
  selectCollections: PropTypes.arrayOf(
    PropTypes.shape({
      cid: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  onSelectedOptionCollection: PropTypes.func.isRequired,
  selectedOptionCollection: PropTypes.object,
};

export default SearchableSelect;
